let userGroups = require('../groups/user');
let redirect = require('../../actions/redirect');

module.exports = {
    checkForAuthCookie: [
        ...userGroups.checkAuthCookie([
            redirect.redirectToRoot
        ])
    ]
};



// WEBPACK FOOTER //
// ./signals/auth/index.js